export default __webpack_public_path__ + "static/media/aggregate-cement.60a22f73.png";